module.exports = __webpack_public_path__ + "static/img/banner-audio-font.d6bf8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/locale/ko/images/banner-audio-font.png
// module id = 7Z7K
// module chunks = 25